/**
 * Where a signed-in person lands.
 *
 * Shelv is a single-purpose product: the recipe book IS the app. The marketing
 * home page (`/`) is for people who are NOT logged in — sending a chef there
 * after login makes them click twice to reach the only thing they came for.
 *
 * Defined once here rather than hardcoded at each redirect site (there were
 * three, all pointing at "/"). Change it here and every entry path follows.
 */
export const POST_LOGIN_LANDING = "/shelv";

/**
 * Resolve where to send someone after a successful login.
 *
 * If they were deep-linked somewhere and got gated (ProtectedRoute stashes the
 * attempted location), honour that — landing them on the recipe book instead of
 * the page they actually asked for is its own small betrayal. Otherwise use the
 * default landing.
 *
 * Only same-origin app paths are accepted, so a crafted `from` can never turn a
 * login into an open redirect.
 */
export const resolvePostLoginPath = (from?: unknown): string => {
  if (typeof from !== "string") return POST_LOGIN_LANDING;
  // Must be an app-relative path: "/shelv/recipes/123" — never "//evil.com" or
  // "https://evil.com", both of which browsers treat as absolute.
  if (!from.startsWith("/") || from.startsWith("//")) return POST_LOGIN_LANDING;
  if (from === "/" || from.startsWith("/login")) return POST_LOGIN_LANDING;
  return from;
};
